<template>
  <section class="address-list">
    <Popup
      v-if="clientPopup.opened"
      title="Редактировать доступы"
      @close="onClientPopupClose"
      @approve="onClientPopupApprove"
    >
      <Select 
        v-model="clientPopup.value"
        :mode="clientPopup.mode"
        :options="clientPopup.options"
        :placeholder="clientPopup.placeholder"
        :multipleLabel="clientPopup.multipleLabel"
        :closeOnSelect="false"
      />
      <small style="color: red; font-size: 12px;" v-if="clientPopup.error">
        Следующие доступы не могут назначаться вместе с другими: <b>{{ clientPopup.restrictedRules.join(',') }}</b>
      </small>
    </Popup>
    <Header class="address-list__title" type="h3">
      <template v-slot:title>Верификация абонентов</template>
    </Header>
    <div class="address-list__notification">
      <Notification
        >Чтобы житель мог пользоваться доступами, вам нужно его
        верифицировать</Notification
      >
    </div>
    <div class="address-list__filters">
      <Filters v-model="filtersActive" :filters="filters" />
    </div>
    <div class="address-list__list">
      <Table
        v-model="rowsSelected"
        :columns="tableColumns"
        :rows="tableRows"
        @switcherClick="onSwitcherClick"
        @rowClick="onRowClick"
      />
      <Pagination v-model="currentPage" v-bind="pagination" @switchPage="onSwitchPage" />
    </div>
    <div class="address-list__actions">
      <Actions
        :values="actionValues"
        :actions="rowsSelected.length ? actions.selected : actions.default"
      />
    </div>
  </section>
</template>

<script>
import Popup from "../../components/Popup.vue";
import Select from "../../components/Form/Select.vue";
import Filters from "Components/Filters.vue";
import Table from "Components/Table.vue";
import Actions from "Components/Actions.vue";
import Notification from "Components/Notification.vue";
import MockGateContactList from "Mixins/Mock/MockGateContactList.js";
import Header from "../../components/Header.vue";
import MockPagination from "../../mixins/Mock/MockPagination.js";
import Pagination from "../../components/Pagination.vue";

export default {
  name: "ContactList",
  mixins: [MockGateContactList, MockPagination],
  components: { Filters, Table, Actions, Notification, Header, Pagination, Popup, Select },
  data() {
    return {
      filtersActive: {},
      rowsSelected: [],
    };
  },
  watch: {
    filtersActive: {
      handler(value) {
        this.filterContacts({
          ...value,
          status: value.status ?? '',
        })
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.address-list {
  &__notification,
  &__title,
  &__filters,
  &__list {
    margin: 0px $space-md $space-lg;
  }
}
</style>
